import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { AudienceSection } from '../components/AudienceSection';
import { TransformationSection } from '../components/TransformationSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { LegalFooter } from '../components/LegalFooter';
import { InlineCTA } from '../components/InlineCTA';
export function LandingPage() {
  return <main className="min-h-screen bg-white font-sans text-[#2D1F0E]" data-id="element-185">
      <HeroSection data-id="element-186" />
      <ProblemSection data-id="element-187" />
      <MechanismSection data-id="element-188" />
      <WhatYouGetSection data-id="element-189" />
      <AudienceSection data-id="element-190" />
      <TransformationSection data-id="element-191" />
      <FAQSection data-id="element-192" />
      <OfferSection data-id="element-193" />
      <LegalFooter data-id="element-194" />
    </main>;
}